/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.orders.list.controllers', [
  'ui.router',
  'acme.common.service.helpers',
  'acme.common.service.calendar'
])

.controller('PartnersOrdersListController', ['$scope', '$state', '$filter', '$timeout', 'CalendarService', 'HelpersService', 'OrdersListData', function($scope, $state, $filter, $timeout, CalendarService, HelpersService, OrdersListData) {

    $scope.partnersOrdersList = {

      model: [],
      filtered: [],
      searchQuery: '',

      init: function() {

        $scope.$emit('Application::contentTitleChange', {
          title: 'Organization Orders'
        });

        if (OrdersListData && OrdersListData.data.success) {
          this.success.init(OrdersListData);
        }else{
          this.error.init(OrdersListData);
        }
      },

      hasOrders: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      search: function() {
        this.filtered = $filter('filter')(this.model, function(order) {
          var name = order.accountName,
              num = order.orderNumber,
            value = (name+''+num).toLowerCase();
          return (value.indexOf($scope.partnersOrdersList.searchQuery.toLowerCase()) !== -1) ? order : null;
        });
      },

      processOrders: function(orders) {
        var i, ii;

        for (i=0,ii=orders.length;i<ii;i++) {
          orders[i].orderDate = CalendarService.parseDate(orders[i].orderDate);
        }

        return orders;
      },

      success: {
        init: function(response) {
          var self = $scope.partnersOrdersList;
          console.log('OrdersListController::success::init', response);
          self.model = self.processOrders(response.data.payload);
          self.search();
          //$scope.setPagingData(self.filtered, $scope.pagingOptions.currentPage, $scope.pagingOptions.pageSize);
        }
      },

      error: {
        init: function(response) {}
      },

      onGridDblClick: function(item) {
        $state.go('application.orders.detail.summary', { accountId: item.entity.accountId, orderId: item.entity.orderId });
      }

    };

    //$scope.myData = [];
    //$scope.filterOptions = {
    //  filterText: "",
    //  useExternalFilter: true
    //};
    //$scope.totalServerItems = 0;
    //$scope.pagingOptions = {
    //  pageSize: 20,
    //  currentPage: 1
    //};
    //$scope.setPagingData = function(data, page, pageSize) {
    //  var pagedData = data.slice((page - 1) * pageSize, page * pageSize);
    //  console.log('paging', data, page, pageSize);
    //
    //  $scope.myData = pagedData;
    //  $scope.totalServerItems = data.length;
    //  if (!$scope.$$phase) {
    //    $scope.$apply();
    //  }
    //};

    //$scope.$watch('pagingOptions', function (newVal, oldVal) {
    //  if (newVal !== oldVal && newVal.currentPage !== oldVal.currentPage) {
    //    console.log('paging', $scope.partnersOrdersList.filtered, $scope.filterOptions.filterText);
    //    $scope.setPagingData($scope.partnersOrdersList.filtered, $scope.pagingOptions.currentPage, $scope.pagingOptions.pageSize);
    //  }
    //}, true);

    //$scope.$watch('partnersOrdersList.searchQuery', function(n, o) {
    //  $scope.partnersOrdersList.search();
    //  $scope.filterOptions.filterText = $scope.partnersOrdersList.searchQuery;
    //});

    //$scope.$watch('filterOptions', function (newVal, oldVal) {
    //  if (newVal !== oldVal) {
    //    console.log('paging', $scope.partnersOrdersList.filtered, $scope.filterOptions.filterText);
    //    $scope.pagingOptions.currentPage = 1;
    //    $scope.setPagingData($scope.partnersOrdersList.filtered, $scope.pagingOptions.currentPage, $scope.pagingOptions.pageSize);
    //  }
    //}, true);

    $scope.gridOptions = {
      //filterOptions: $scope.filterOptions,
      showFooter: true,
      multiSelect: false,
      paginate: true,
      pageSize: 50,

      columnDefs: [
        {
          field: 'accountId',
          visible: false
        },
        {
          field: 'orderId',
          visible: false
        },
        {
          field: 'accountName',
          displayName: 'Organization',
          sort: {
            direction: 'asc'
          }
        },
        {
          field: 'orderNumber',
          displayName: 'Order No.'
        },
        {
          field: 'totalAmount',
          displayName: 'Original Price',
          cellFilter: 'currency'
        },
        {
          field: 'discountedTotalAmount',
          displayName: 'Discounted Price',
          cellFilter: 'currency'
        },
        {
          field: 'orderBalance',
          displayName: 'Balance Due',
          cellFilter: 'currency'
        },
        {
          field: 'orderDate',
          displayName: 'Order Date',
          cellFilter: 'date: "'+HelpersService.dateFormats.shortDate+'"'
        }
      ]
    };

    $scope.partnersOrdersList.init();

}]);